enum XComEventTypes {
    SearchPatient,
    DocumentList,
    FileViewed,
    AccessWithoutConsent
}

export { XComEventTypes };
